import { jsx as _jsx } from "react/jsx-runtime";
import { MetaNavigationList } from "./MetaNavigation.styles";
import { MetaNavigationItem, } from "./MetaNavigationItem";
export const MetaNavigation = ({ label, items, previewId, previewIdExtractor, }) => {
    return (_jsx("nav", Object.assign({ "aria-label": label }, { children: _jsx(MetaNavigationList, Object.assign({ "data-preview-id": previewId }, { children: items.map(({ title, target, className, onClick }, index) => (_jsx(MetaNavigationItem, { "data-preview-id": typeof previewIdExtractor === "function"
                    ? previewIdExtractor({ title, target, className }, index)
                    : undefined, className: className, title: title, target: target, onClick: onClick }, title.replace(/\W+/, "")))) })) })));
};
